import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import SectionHeader from 'design-system/SectionHeader';
import Text from 'design-system/Text';
const strings = {
    GETTING_STARTED: 'Getting started',
    TRANSACTION_NINJA: 'Become a ninja',
    MASTER_ACCOUNTS: 'Master your accounts',
    LIKE_A_PRO: 'Emma like a Pro',
    SAVE_MONEY: 'Save money',
    START_INVESTING: 'Start investing',
};
const QuestsSectionHeader = ({ section }) => {
    const { width } = useAppFrameDimensions();
    const { key, totalCount, completedCount } = section;
    const title = strings[key];
    if (!title)
        return null;
    return (<SectionHeader largeVerticalMargins style={[styles.container, { width }]} button={<Text Text-16 Primary>
          {completedCount}/{totalCount}
        </Text>}>
      {title}
    </SectionHeader>);
};
const styles = StyleSheet.create({
    container: {
        paddingTop: rem(24),
        flexDirection: 'row',
        paddingHorizontal: rem(16),
    },
});
export default memo(QuestsSectionHeader);
